<template>
  <a-card :bordered="false" title="智能海报" :bodyStyle="{paddingTop:'0px'}"
          :headStyle="{borderBottom:'0px',fontSize:'18px'}">
    <div class="page">
      <a-list :loading="loading" :data-source="posterList"
              :grid="{ gutter: 24, xxl: 4, xl: 3, lg: 2, md: 2, sm: 2, xs: 1 }">
        <a-list-item slot="renderItem" slot-scope="item">
          <a-card class="ant-pro-pages-account-projects-card" hoverable>
            <div class="image-box" slot="cover" @click="previewImg(item.example)">
              <img :src="item.example" alt=""/>
            </div>
            <a-card-meta :title="item.value"></a-card-meta>
          </a-card>
        </a-list-item>
      </a-list>
    </div>
    <!-- 图片预览插件 -->
    <PreviewImage v-if="imgDialogVisible" :dialogVisible="imgDialogVisible" :imageUrl="imageUrl"
                  @close="closeData"></PreviewImage>
  </a-card>
</template>

<script>
import PreviewImage from '@/views/platform/component/PreviewImage'

export default {
  name: 'PosterTemplate',
  components: {
    PreviewImage
  },
  data() {
    return {
      imgDialogVisible: false,
      loading: false,
      imageUrl: '',
      posterList: []
    }
  },
  created() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [{ name: 'SmartPoster', title: '我的海报' }, {
      name: 'PosterTemplate',
      title: '海报模板'
    }])
  },
  mounted() {
    this.getPosterTemplate()
  },
  methods: {
    // 关闭图片预览
    closeData() {
      this.imageUrl = ''
      this.imgDialogVisible = false
    },
    // 点击图片预览
    previewImg(imgUrl) {
      this.imgDialogVisible = true
      this.imageUrl = imgUrl
    },
    // 获取海报模板
    getPosterTemplate() {
      this.getHttpServices().getServerApiService().post('poster/getPosterTemplate', {
        platformId: this.getPlatformConfig().platformId,
        merchantId: this.$store.getters.userInfo.merchantId
      }).then(res => {
        this.posterList = res
        this.getLogUtils().logWithTag('getPosterTemplate', res)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }
}
</script>
<style scoped lang="less">
.ant-btn + .ant-btn {
  margin-left: 5px;
}

.page {
  .image-box {
    width: 100%;
    height: 230px;
    overflow: hidden;

    img {
      width: 100%;
      height: auto;
    }
  }

  /deep/ .ant-card-meta-title {
    margin-bottom: 4px;
  }

  /deep/ .ant-card-meta-description {
    height: 44px;
    overflow: hidden;
    line-height: 22px;
  }
}
</style>